import './App.css';
import TumblrLandingPage from './components/tumblr_home/TumblrLandingPage';

function App() {
  return (
    <div className="App">
      <TumblrLandingPage />
     
    </div>
  );
}

export default App;
